import {
    Box, Paper, Stack, ToggleButtonGroup, ToggleButton, TextField, InputAdornment,
    FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText, OutlinedInput,
    FormControlLabel, Switch, Chip,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const ITEM_HEIGHT = 48;
const MAX_MENU_HEIGHT = ITEM_HEIGHT * 8 + 8;

export default function CatalogueFilters({
    view, onViewChange,
    searchRaw, onSearchChange,
    categories, categoryIds, onCategoryIdsChange,
    inStockOnly, onInStockOnlyChange,
    favoritesCount = 0,
}) {
    const handleCategoryChange = (event) => {
        const value = event.target.value;
        onCategoryIdsChange(Array.isArray(value) ? value : []);
    };

    return (
        <Paper sx={{ p: 2 }}>
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems={{ md: 'center' }} flexWrap="wrap">
                <ToggleButtonGroup
                    exclusive
                    size="small"
                    value={view}
                    onChange={(_, v) => v && onViewChange(v)}
                >
                    <ToggleButton value="history">Mes produits</ToggleButton>
                    <ToggleButton value="favorites">
                        Favoris
                        {favoritesCount > 0 && (
                            <Chip
                                size="small"
                                label={favoritesCount}
                                sx={{ ml: 0.75, height: 18, fontSize: 11, pointerEvents: 'none' }}
                            />
                        )}
                    </ToggleButton>
                    <ToggleButton value="all">Tout le catalogue</ToggleButton>
                </ToggleButtonGroup>

                <TextField
                    placeholder="Rechercher par nom ou SKU…"
                    value={searchRaw}
                    onChange={(e) => onSearchChange(e.target.value)}
                    InputProps={{
                        startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment>,
                    }}
                    sx={{ minWidth: { md: 260 } }}
                />

                <FormControl size="small" sx={{ minWidth: { md: 220 }, flex: { md: '0 0 auto' } }}>
                    <InputLabel id="b2b-catalogue-cat-label">Catégories</InputLabel>
                    <Select
                        labelId="b2b-catalogue-cat-label"
                        multiple
                        value={categoryIds}
                        onChange={handleCategoryChange}
                        input={<OutlinedInput label="Catégories" />}
                        renderValue={(selected) => (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                {selected.map((id) => {
                                    const cat = categories.find(c => c.id === id);
                                    return cat ? <Chip key={id} label={cat.name} size="small" /> : null;
                                })}
                            </Box>
                        )}
                        MenuProps={{ PaperProps: { sx: { maxHeight: MAX_MENU_HEIGHT } } }}
                    >
                        {categories.length === 0 ? (
                            <MenuItem disabled value="">Aucune catégorie</MenuItem>
                        ) : categories.map((cat) => (
                            <MenuItem key={cat.id} value={cat.id}>
                                <Checkbox checked={categoryIds.includes(cat.id)} size="small" />
                                <ListItemText primary={cat.name} />
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControlLabel
                    control={<Switch checked={inStockOnly} onChange={(e) => onInStockOnlyChange(e.target.checked)} />}
                    label="En stock seulement"
                />
            </Stack>
        </Paper>
    );
}
